/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Origin = {
    PoolOfFreelancers: 'POOL_OF_FREELANCERS',
    SearchProposal: 'SEARCH_PROPOSAL'
} as const;
export type Origin = typeof Origin[keyof typeof Origin];


export function instanceOfOrigin(value: any): boolean {
    for (const key in Origin) {
        if (Object.prototype.hasOwnProperty.call(Origin, key)) {
            // @ts-ignore
            if (Origin[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OriginFromJSON(json: any): Origin {
    return OriginFromJSONTyped(json, false);
}

export function OriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): Origin {
    return json as Origin;
}

export function OriginToJSON(value?: Origin | null): any {
    return value as any;
}

